module.exports={
	"Form": "SampleStatusViewManifest",
	"Scope": "SampleStatus-View",
	"Descriptors":
	{
		"SampleStatusDetails.Name":
		{
			"Name": "Name",
			"Hash": "SampleStatus-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "SampleStatus-View-Identity",
				"Group": "SampleStatus-View-Identity"
			}
		},
		"SampleStatusDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "SampleStatus-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "SampleStatus-View-Details",
				"Group": "SampleStatus-View-Details"
			}
		},
		"SampleStatusDetails.Description":
		{
			"Name": "Description",
			"Hash": "SampleStatus-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "SampleStatus-View-Details",
				"Group": "SampleStatus-View-Details"
			}
		},
		"SampleStatusDetails.Category":
		{
			"Name": "Category",
			"Hash": "SampleStatus-View-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "SampleStatus-View-Details",
				"Group": "SampleStatus-View-Details"
			}
		},
		"SampleStatusDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "SampleStatus-View-Ordinal",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "SampleStatus-View-Details",
				"Group": "SampleStatus-View-Details"
			}
		},
		"SampleStatusDetails.IDSampleStatus":
		{
			"Name": "IDSample Status",
			"Hash": "SampleStatus-View-IDSampleStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "SampleStatus-View-DataAudit",
				"Group": "SampleStatus-View-DataAudit"
			}
		},
		"SampleStatusDetails.GUIDSampleStatus":
		{
			"Name": "GUIDSample Status",
			"Hash": "SampleStatus-View-GUIDSampleStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "SampleStatus-View-DataAudit",
				"Group": "SampleStatus-View-DataAudit"
			}
		},
		"SampleStatusDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "SampleStatus-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "SampleStatus-View-DataAudit",
				"Group": "SampleStatus-View-DataAudit"
			}
		},
		"SampleStatusDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "SampleStatus-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "SampleStatus-View-DataAudit",
				"Group": "SampleStatus-View-DataAudit"
			}
		},
		"SampleStatusDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "SampleStatus-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "SampleStatus-View-DataAudit",
				"Group": "SampleStatus-View-DataAudit"
			}
		},
		"SampleStatusDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "SampleStatus-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "SampleStatus-View-DataAudit",
				"Group": "SampleStatus-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "SampleStatus-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "SampleStatus-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "SampleStatus-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "SampleStatus-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "SampleStatus-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "SampleStatus-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
